import { startGame } from '@sl/base/main';
import { Scene } from '@sl/base/scene';
import { Bonus } from '@sl/games/vikings/bonus';
import { Payline } from '@sl/base/logic/payline';
import { Winning } from '@sl/base/logic/winning';

class GameScene extends Scene {
    update() {
        super.update();
    }

    init() {
        super.init();

        this.letInitialize(() => {
            this.winTable = undefined;
            this.winText = undefined;
            this.amountWonStep = 15;
            this.amountWonTimeout = 40;
            this.amountWonFadeInSpeed = 300;
            this.slots.symbolBlurFrame = 25;
            this.positionerContainer = this.add.container();

            this.createBg();
            this.slots.createSlotMachine();
            this.addGameLogo();
            this.addSymbolsAnimations();

            this.bonus = new Bonus(this);
            this.payline = new Payline(this);
            this.winning = new Winning(this);

            this.payline.drawPaylines();
            this.spinSound = this.sound.add('spin', {"loop":true, "volume": 0.2});
            this.createWinningsContainer();

            this.spritesReady = true;
            
            this.baseGamePositioner();
        });
    }

    afterPurchase() {
        this.winning.removeTimers();
        this.slots.spin();
    }

    afterStep() {
        const { scenario } = this.request;

        if (scenario) {
            if(!this.skip && scenario.freespins && parseInt(scenario.freespins.current) === 1) {
                this.bonus.init(() => {
                    this.afterPurchase();
                });
            } else {
                if (scenario.reels) {
                    this.afterPurchase();
                } 
            }

            return;
        }

        this.request.spinFinished();
    }

    createWinningsContainer() {
        this.winningsContainer = this.add.container();
        this.winningsContainer.alpha = 0;

        let sprite = this.add.sprite(this.slots.frame.x, this.slots.frame.y, 'Mega_Spark').setOrigin(0.5, 0.5);
        sprite.name = 'sparkle';
        this.winningsContainer.add(sprite);
        sprite = this.add.sprite(this.slots.frame.x + 115, this.slots.frame.y + 200, 'Mega_Axe_02').setOrigin(1, 1);
        sprite.name = 'axe_02';
        this.winningsContainer.add(sprite);
        sprite = this.add.sprite(this.slots.frame.x - 105, this.slots.frame.y + 200, 'Mega_Axe_01').setOrigin(0, 1);
        sprite.name = 'axe_01';
        this.winningsContainer.add(sprite);
        sprite = this.add.sprite(this.slots.frame.x, this.slots.frame.y, 'Mega_Base').setOrigin(0.5, 0.5);
        sprite.name = 'base';
        this.winningsContainer.add(sprite);
        let winAmount = this.add.bitmapText(this.slots.frame.x, this.slots.frame.y, 'winning_font', 0, 60).setOrigin(0.5, 0.5);
        winAmount.name = 'win_amount';
        this.winningsContainer.add(winAmount);
        sprite = this.add.sprite(this.slots.frame.x, this.slots.frame.y, 'Mega_Spark').setOrigin(0.5, 0.5);
        sprite.name = 'sparkle_outside';
        this.winningsContainer.add(sprite);
    }

    createBg() {
        this.bg = this.add.sprite(0, 0, 'bg').setOrigin(0.5, 0);
        this.positionerContainer.add(this.bg);
    }

    addGameLogo() {
        this.logo = this.add.sprite(0, 0, 'logo').setOrigin(0.5, 0.5);
    }

    afterSpin() {
        this.request.step();
    }

    addSymbolsAnimations() {
        for(const [ reelIndex, reel ] of Object.entries(this.slots.reelsContainersObjects)) {
            for(const symbolIndex of Object.keys(reel.symbols)) {
                let symbol = reel.symbols[symbolIndex];
                
                let frames = [];

                for(let i = 0; i < 23; i++) {
                    frames.push(i);
                }

                frames.push(0);

                var config = {
                    key: `${symbol.texture.key}`,
                    skipMissedFrames: true,
                    frames: this.anims.generateFrameNumbers(`${symbol.texture.key}`, {
                        start: 0,
                        end: 24,
                    }),
                    frameRate: 10,
                    yoyo: 0,
                    repeat: 0
                };
            
                this.anims.create(config);
                symbol.anims.load(`${symbol.texture.key}`);
            }
        }
    }

    /*drawPaylines() {
        const halfSymbolHeight = this.slots.symbolHeight / 2;
        const offsetY = this.slots.frame.y + 10;

        this.payline.paylines[1] = this.add.sprite(this.slots.frame.x, offsetY, 'payline_1').setOrigin(0.5, 0.5);
        this.payline.paylines[2] = this.add.sprite(this.slots.frame.x, offsetY - this.slots.symbolHeight, 'payline_1').setOrigin(0.5, 0.5);
        this.payline.paylines[3] = this.add.sprite(this.slots.frame.x, offsetY + this.slots.symbolHeight, 'payline_1').setOrigin(0.5, 0.5);
        this.payline.paylines[4] = this.add.sprite(this.slots.frame.x, offsetY, 'payline_4').setOrigin(0.5, 0.5);
        this.payline.paylines[5] = this.add.sprite(this.slots.frame.x, offsetY, 'payline_5').setOrigin(0.5, 0.5);
        this.payline.paylines[6] = this.add.sprite(this.slots.frame.x, offsetY + halfSymbolHeight, 'payline_6_9').setOrigin(0.5, 0.5);
        this.payline.paylines[7] = this.add.sprite(this.slots.frame.x, offsetY - halfSymbolHeight, 'payline_7_8').setOrigin(0.5, 0.5);
        this.payline.paylines[8] = this.add.sprite(this.slots.frame.x, offsetY + halfSymbolHeight, 'payline_7_8').setOrigin(0.5, 0.5);
        this.payline.paylines[9] = this.add.sprite(this.slots.frame.x, offsetY - halfSymbolHeight, 'payline_6_9').setOrigin(0.5, 0.5);
        this.payline.paylines[10] = this.add.sprite(this.slots.frame.x, offsetY - halfSymbolHeight, 'payline_10_18').setOrigin(0.5, 0.5);
        this.payline.paylines[11] = this.add.sprite(this.slots.frame.x, offsetY + halfSymbolHeight, 'payline_11_19').setOrigin(0.5, 0.5);
        this.payline.paylines[12] = this.add.sprite(this.slots.frame.x, offsetY, 'payline_12').setOrigin(0.5, 0.5);
        this.payline.paylines[13] = this.add.sprite(this.slots.frame.x, offsetY, 'payline_13').setOrigin(0.5, 0.5);
        this.payline.paylines[14] = this.add.sprite(this.slots.frame.x, offsetY - halfSymbolHeight, 'payline_14_21').setOrigin(0.5, 0.5);
        this.payline.paylines[15] = this.add.sprite(this.slots.frame.x, offsetY + halfSymbolHeight, 'payline_15_20').setOrigin(0.5, 0.5);
        this.payline.paylines[16] = this.add.sprite(this.slots.frame.x, offsetY, 'payline_16').setOrigin(0.5, 0.5);
        this.payline.paylines[17] = this.add.sprite(this.slots.frame.x, offsetY, 'payline_17').setOrigin(0.5, 0.5);
        this.payline.paylines[18] = this.add.sprite(this.slots.frame.x, offsetY + halfSymbolHeight, 'payline_10_18').setOrigin(0.5, 0.5);
        this.payline.paylines[19] = this.add.sprite(this.slots.frame.x, offsetY - halfSymbolHeight, 'payline_11_19').setOrigin(0.5, 0.5);
        this.payline.paylines[20] = this.add.sprite(this.slots.frame.x, offsetY - halfSymbolHeight, 'payline_15_20').setOrigin(0.5, 0.5);
        this.payline.paylines[21] = this.add.sprite(this.slots.frame.x, offsetY + halfSymbolHeight, 'payline_14_21').setOrigin(0.5, 0.5);
        this.payline.paylines[22] = this.add.sprite(this.slots.frame.x, offsetY, 'payline_22').setOrigin(0.5, 0.5);
        this.payline.paylines[23] = this.add.sprite(this.slots.frame.x, offsetY, 'payline_23').setOrigin(0.5, 0.5);
        this.payline.paylines[24] = this.add.sprite(this.slots.frame.x, offsetY, 'payline_24').setOrigin(0.5, 0.5);
        this.payline.paylines[25] = this.add.sprite(this.slots.frame.x, offsetY, 'payline_25').setOrigin(0.5, 0.5);
        
        for(const [ paylineIndex, payline ] of Object.entries(this.payline.paylines)) {
            payline.name = `payline_${paylineIndex}`;
            this.payline.paylinesContainer.add(payline);
            this.slots.reelsContainer.add(payline);
        }

        this.slots.reelsContainer.add(this.payline.paylinesContainer);

        this.payline.hidePaylines();
    }*/

    showWinning(text, callback) {
        let win = 'Mega';
        let sound = 'Mega';

        if(!text) {
            var winningAmount = this.request.scenario.amount_won;

            if(!winningAmount) {
                this.winning.playPaylines();

                if(callback) {
                    callback();
                }

                return;
            }

            var currentAmount = 0;

            win = 'Regular';
            sound = 'Big';

            if(this.request.scenario.tags.big_win) {
                win = 'Big';
            }
        }

        this.prepareWinningContainer(win);

        this.winningsContainer.tween = this.tweens.add({
            targets: [this.winningsContainer],
            alpha: 1,
            ease: 'Power0',
            duration: 200,
            yoyo: 0,
            repeat: 0,
        });

        this.winningsContainer.getByName('sparkle').tween = this.tweens.add({
            targets: [this.winningsContainer.getByName('sparkle')],
            alpha: 1,
            ease: 'Power0',
            duration: 30,
            yoyo: -1,
            repeat: -1,
        });

        this.winningsContainer.getByName('sparkle_outside').tween = this.tweens.add({
            targets: [this.winningsContainer.getByName('sparkle_outside')],
            scale: 1,
            alpha: 1,
            ease: 'Power0',
            duration: 200,
            yoyo: 1,
            repeat: 0,
        });

        this.sound.play('blades');

        this.winningsContainer.getByName('axe_01').tween = this.tweens.add({
            targets: [this.winningsContainer.getByName('axe_02'), this.winningsContainer.getByName('axe_01')],
            angle: 0,
            ease: 'Power0',
            duration: 200,
            yoyo: 0,
            repeat: 0,
            delay: 50,
            onComplete: () => {
                this.winningsContainer.getByName('win_amount').setText(text ? text : 0);
                
                this.sound.play(sound);
        
                const tween = this.tweens.add({
                    targets: [this.winningsContainer.getByName('win_amount')],
                    alpha: 1,
                    ease: 'Power0',
                    duration: this.amountWonFadeInSpeed,
                    yoyo: 0,
                    repeat: 0,
                    onComplete: () => {
                        if(!text) {
                            let timeout = 0;
                            let step = winningAmount / this.amountWonStep;
                            let last = false;

                            if(win === 'Big') {
                                step = winningAmount / (this.amountWonStep * 3);
                            }
            
                            while(currentAmount < winningAmount) {
                                currentAmount += step;
            
                                if(currentAmount > winningAmount) {
                                    currentAmount = winningAmount;
                                }
            
                                if(currentAmount === winningAmount) {
                                    last = true;
                                }
            
                                let timer = this.time.delayedCall(timeout, this.setAmountText, [currentAmount, last, false, false], this);
            
                                this.winning.timers.push(timer);
                                timeout += this.amountWonTimeout;
                            }
                        } else {
                            let timer = this.time.delayedCall(0, this.setAmountText, [text, true, callback, true], this);
                            this.winning.timers.push(timer);
                        }
                    },
                });
                this.winningsContainer.getByName('win_amount').tween = tween;
                this.winning.tweenTimers.push(tween);
            }
        });
    }

    setAmountText(amount, last, callback, string) {
        if(!string) {
            amount = parseFloat(amount).toFixed(Config.currency.precision);
            this.sound.play('coin');
        }

        this.winningsContainer.getByName('win_amount').setText(amount);

        if(last) {
            const tween = this.tweens.add({
                targets: [this.winningsContainer],
                alpha: 0,
                ease: 'Power0',
                duration: this.amountWonFadeInSpeed,
                yoyo: 0,
                repeat: 0,
                delay: 4 * this.amountWonFadeInSpeed,
                onComplete: () => {
                    this.winning.playPaylines();

                    if(callback) {
                        callback();
                    }
                },
            });

            this.winning.tweenTimers.push(tween);
        }
    }

    prepareWinningContainer(win) {
        this.hideWinTable();

        let texture = win;
        let axe = win;

        if(win === 'Regular') {
            axe = 'Big';
        } 

        this.winningsContainer.alpha = 0;
        this.winningsContainer.getByName('sparkle_outside').setScale(0);
        this.winningsContainer.getByName('sparkle_outside').alpha = 0;
        this.winningsContainer.getByName('axe_01').angle = -60;
        this.winningsContainer.getByName('axe_02').angle = 60;

        this.winningsContainer.getByName('sparkle_outside').setTexture(`${texture}_Spark`);
        this.winningsContainer.getByName('base').setTexture(`${texture}_Base`);

        this.winningsContainer.getByName('axe_01').setTexture(`${axe}_Axe_01`);
        this.winningsContainer.getByName('axe_02').setTexture(`${axe}_Axe_02`);
        this.winningsContainer.getByName('sparkle').setTexture(`${texture}_Spark`);
        this.winningsContainer.getByName('sparkle').alpha = 0.7;
        this.winningsContainer.getByName('win_amount').alpha = 0;
    }

    hideWinTable() {
        if(this.winningsContainer && this.winningsContainer.alpha) {
            if(this.winningsContainer.tween && this.winningsContainer.tween.isPlaying()) {
                this.winningsContainer.tween.stop();
                this.winningsContainer.tween.remove();
            }
        
            this.winningsContainer.alpha = 0;

            for(const [symbolIndex, sprite] of Object.entries(this.winningsContainer.getAll())) {
                if(sprite.tween && sprite.tween.isPlaying()) {
                    sprite.tween.stop();
                    sprite.tween.remove();
                }
            }
        }
    }

    playSpinSound() {
        this.spinSound.play();
    }

    muteSpinSound() {
        this.spinSound.stop();
    }

    playStopSound() {
        this.sound.play('click', {"volume":0.4});
    }

    playWinlineSound() {
        this.sound.play('gem');
    }

    skipAnimations() {
        this.winning.removeTimers();
        this.hideWinTable();
        this.skip = true;
        this.winning.doCallback();
    }

    addPaylineAnimations(graphics, points) {
        let curve = new Phaser.Curves.Spline(points);
        let particle = this.add.particles('flares');

        graphics.particle = particle;

        graphics.particleConfig = {
            x: 0,
            y: 0,
            blendMode: 'SCREEN',
            frame: Config.settings.particle_frame ? Config.settings.particle_frame : 0,
            scale: { start: 0.4, end: 0 },
            speed: { min: 30, max: 60},
            quantity: 50,
            on: false,
            emitZone: {  type: 'random', source: curve, quantity: 50 },
        };

        this.slots.reelsContainer.add(particle);

        return graphics;
    }

    overspinAnimationConfig(overspinReel) {
        var curve = new Phaser.Curves.Path(0, 0);

        curve.lineTo(this.slots.symbolWidth, 0);
        curve.lineTo(this.slots.symbolWidth, this.slots.frameMaskHeight);
        curve.lineTo(0, this.slots.frameMaskHeight);
        curve.lineTo(0, 0);
        
        return {
            x: overspinReel.x - this.slots.symbolWidth / 2,
            y: overspinReel.y - this.slots.frameMaskHeight / 2,
            blendMode: 'SCREEN',
            scale: { start: Phaser.Math.Between(50, 80) / 100, end: 0 },
            speed: 20,
            quantity: 20,
            lifespan: 500,
            frame: Config.settings.particle_frame ? Config.settings.particle_frame : 0,
            emitZone: {
                source: curve,
                type: 'random',
                quantity: 40
            }
        }
    }

    gamePositioner() {
        if(!this.spritesReady) {
            return;
        }

        this.bonus.explodeContainer.x = this.cameras.main.centerX;
        this.bonus.explodeContainer.y = 0;

        this.logo.x = this.slots.frame.x + this.cameras.main.centerX;
        this.logo.y = 120 + this.slots.frameTopOffset;
    }
}

startGame(GameScene);